import * as React from "react";
const MinusSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M15.5,10 L15.5,11 L4.5,11 L4.5,10 L15.5,10 Z" }));
MinusSmall.displayName = "MinusSmall";
var MinusSmall_default = MinusSmall;
export {
  MinusSmall_default as default
};
